import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import moment from "moment";

const ADD_HOSTEL_ATTENDANCE = gql`
  mutation($params: AddHostelAttendance) {
    addHostelAttendance(params: $params)
  }
`;

class SubmitHostelAttendanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      submitError: "",
      loadingSpinner: 0,
    };
  }

  handleFormSubmit = (e) => {

    e.preventDefault();

    let studentDetails = [];
    this.props.stateData.capacityDetails.map((item) => {
      studentDetails.push({ edu_student_id: item.edu_student_id, attendance_status: parseInt(item.attendance_status), room_id: parseInt(item.roomSearch) })
      console.log("item123", studentDetails);
    })

    let roomSearch = this.props.stateData.capacityDetails.some((item) => item.edu_student_id == studentDetails.edu_student_id)
    console.log(("roomSearch", roomSearch));

    let params = {
      room_id: this.props.stateData.capacityDetails.map((item) => item.roomSearch).toString(),
      attended_date: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
      inserted_by: parseInt(Cookies.get("id")),
      hostel_attendance: studentDetails
    };
    console.log("params", params);

    this.setState({ loadingSpinner: 1 })

    this.addHostelAttendance(params).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message),
        loadingSpinner: 0
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map(x => x.message)
      );
    });

  }


  addHostelAttendance = async params => {
    console.log("child");
    await this.props.addHostelAttendance({
      variables: {
        params
      },
      update: (store, { data }) => {
        console.log("data", data);
        if (data.addHostelAttendance) {
          this.setState({
            currentStep: 5,
            loadingSpinner: 0
          });
          setTimeout(() => {
            this.SetpageLoad();
          }, 1000);
        }
      }
    });
  };

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "" });
    // Refresh the table in place instead of reloading the whole page.
    if (this.props.onSubmitted) {
      this.props.onSubmitted();
    } else {
      this.props.onHide();
    }
  };


  render() {
    console.log("props", this.props);
    return (
      <Modal
        {...this.props}
        size="md"
        aria-labelledby="example-modal-sizes-title-lg"

      >
        <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)", borderBottom: "none" }}>
          <Modal.Title style={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>Hostel Attendance confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "22px 24px", background: "#fff" }}>
          <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
            <i className="fal fa-info-circle mr-2" style={{ color: "#6366f1" }} />
            Please review the summary before confirming attendance{this.props.stateData.date ? ` for ${this.props.stateData.date}` : ""}.
          </p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
            {[
              { label: "Total", value: this.props.stateData.totalStudents, color: "#4f46e5", tint: "#eef2ff", border: "#e0e7ff", icon: "fal fa-users" },
              { label: "Present", value: this.props.stateData.presentStudents, color: "#059669", tint: "#ecfdf5", border: "#bbf7d0", icon: "fal fa-check-circle" },
              { label: "Absent", value: this.props.stateData.absentStudents, color: "#dc2626", tint: "#fef2f2", border: "#fecaca", icon: "fal fa-times-circle" },
            ].map((c) => (
              <div key={c.label} style={{ display: "flex", alignItems: "center", gap: 8, background: c.tint, border: `1px solid ${c.border}`, borderRadius: 8, padding: "7px 12px" }}>
                <i className={c.icon} style={{ color: c.color, fontSize: 14 }} />
                <span style={{ fontSize: 18, fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</span>
                <span style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.4px" }}>{c.label}</span>
              </div>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #f1f5f9", padding: "14px 24px", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
          {this.state.currentStep == 5 ? (
            <div style={{ textAlign: "center", color: "#059669", background: "#ecfdf5", border: "1px solid #bbf7d0", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
              <i className="fal fa-check-circle mr-2" />Attendance added successfully
            </div>
          ) : null}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" onClick={this.props.onHide} style={{ background: "#fff", border: "1.5px solid #e5e7eb", color: "#475569", borderRadius: 10, padding: "9px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
              Cancel
            </button>
            <button onClick={this.handleFormSubmit} type="submit" style={{ background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)", border: "none", color: "#fff", borderRadius: 10, padding: "9px 24px", fontWeight: 700, fontSize: 14, cursor: "pointer", boxShadow: "0 4px 12px rgba(99,102,241,0.3)", display: "inline-flex", alignItems: "center", gap: 8 }}>
              {this.state.loadingSpinner == 1 ? (<span className="spinner-border spinner-border-sm"></span>) : <i className="fal fa-check" />}
              Confirm
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}
export default graphql(ADD_HOSTEL_ATTENDANCE, {
  name: "addHostelAttendance"
})(SubmitHostelAttendanceModal);